import React, {useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import {Link} from "react-router-dom";

export default function ContactUs (){
  const form = useRef();
  const [status, setStatus] = useState(undefined);
  const [loading, setLoading] = useState(false);


  const sendEmail = (e) => {

    e.preventDefault();
    setLoading(true)

    emailjs.sendForm('service_3wiajyk', 'template_vea9jto', form.current, 'AlHQMatKwsrj9qyR7')


        .then((result) => {


          setStatus({ type: 'success' });

          console.log(loading)

        }, (error) => {
          console.log(error.text);
        });
  };

  return (


      <form className="contact_form" ref={form} onSubmit={sendEmail}>





        <div className="form_title_wrapper">
          <h5>Über dich</h5>
        </div>




        <div className="contact_divider"></div>

        <div className="field_wrapper w-50 radio-section">
          <div className="field_wrapper">
            <label className="artist-radio">Tattoo Artist <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>

            <label className="container">Karlie (@karlie.tattoo)
              <input type="radio" name="appointment" value="hello@studioaugust.de" />
              <span className="checkmark"></span>
            </label>

            <label className="container">Patrycja (@patis.tattis)
              <input type="radio" name="appointment" value="please@inkonme.de" />
              <span className="checkmark"></span>
            </label>

          </div>
        </div>

        <div className="field_wrapper_container">
          <div className="field_wrapper-row">
            <div className="field_wrapper w-50">
              <label>Vorname  <span className="mandatory">
                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
                </svg>
              </span>
              </label>

              <input type="text" name="client_first_name" required />
            </div>

            <div className="field_wrapper w-50">
              <label>Nachname <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
              <input type="text" name="client_last_name" required />
            </div>
          </div>

          <div className="field_wrapper-row">
            <div className="field_wrapper w-50">
              <label>Email <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
              <input type="email" name="client_email" required />
            </div>

            <div className="field_wrapper w-50">
              <label>bestätige deine Email-Adresse <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
              <input type="email" name="client_confirm_email" required />
            </div>
          </div>

          <div className="field_wrapper-row">
            <div className="field_wrapper w-50">
              <label>Telefonnummer <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
              <input type="text" name="client_phone" required />
            </div>

            <div className="field_wrapper w-50">
              <label>Alter <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
              <input type="text" name="client_age" required />
            </div>
          </div>
        </div>



        <div className="form_title_wrapper">
          <h5>Dein Tattoo</h5>
        </div>

        <div className="contact_divider spacer"></div>


        <div className="field_wrapper w-100">
          <label>Erzähle uns von deiner Tattoo-Idee <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
          <span className="divider"></span>
          <textarea name="client_idea" required />
        </div>

        <div className="field_wrapper-row">
          <div className="field_wrapper w-50">
            <label>Körperstelle <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
            <input type="text" name="client_bodyarea" required />
          </div>

          <div className="field_wrapper w-50">
            <label>Größe (am besten mit Lineal gemessen) <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>
            <input type="text" name="client_size" required />
          </div>

        </div>




        <div className="field_wrapper">
          <label>welche Tage passen bei dir für einen Termin am besten? (Nenne uns 3 Beispieltermine und Tageszeit) <span className="mandatory">

                <svg className="mandatory" width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.57386 6.90909L3.63636 4.25568L1.36932 5.64205L0.948864 4.90341L3.28977 3.63636L0.948864 2.36932L1.36932 1.63068L3.63636 3.01705L3.57386 0.363636H4.42614L4.36364 3.01705L6.63068 1.63068L7.05114 2.36932L4.71023 3.63636L7.05114 4.90341L6.63068 5.64205L4.36364 4.25568L4.42614 6.90909H3.57386Z" fill="#997867"/>
</svg>
              </span></label>

          <textarea name="appointment_time" required />
        </div>


        <div className="field_wrapper">
          <label>Beispielbilder (du kannst bis zu 5 Bilder senden) (20Mb max)</label>

          <div className="upload_wrapper">
            <div className="upload_inner_wrapper">
              <input className="custom-file-input" id="test" type="file" name="image" multiple="multiple"   />
            </div>
          </div>
        </div>



        <div className="field_wrapper">
          <label className="container">ich habe die <Link class="link" to="/datenschutz" target="_blank">Datenschutzerklärung</Link> gelesen und stimme dieser zu.
            <input type="checkbox" name="Data" value="yes" required />
            <span className="checkmark"></span>
          </label>
        </div>



        <div className="field_wrapper">
          <button className="button" type="submit">{loading ? <>

            <span className="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>

          </span></> : <>Senden</>}
          </button>




        </div>


        {status?.type === 'success' &&

        <div className="success_modal_main_wrapper">
          <div className="success_modal_wrapper">
            <div className="success_modal">
              <div className="success_logo">
                <svg width="127" height="30" viewBox="0 0 127 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.456 22.48C10.464 22.48 12.384 19.92 12.992 16.976H13.28C13.248 18.736 13.024 20.368 12.448 22H21.696V4.88H20.864L14.784 7.792H14.688C13.344 5.712 11.104 4.432 8.384 4.432C3.712 4.432 0.448 8.464 0.448 13.456C0.448 18.8 3.296 22.48 7.456 22.48ZM11.328 15.728C9.984 15.728 9.024 14.672 9.024 13.36C9.024 12.048 10.016 10.992 11.36 10.992C12.672 10.992 13.664 12.016 13.664 13.328C13.664 14.672 12.672 15.728 11.328 15.728ZM29.7938 22.48C32.3218 22.48 34.4978 21.392 35.4578 18.768H35.7138C35.6178 19.952 35.4258 20.88 35.1058 22H44.0978V4.88H35.7458V13.328C35.7458 14.672 34.9778 15.568 33.7618 15.568C32.5138 15.568 31.7778 14.672 31.7778 13.328V4.88H23.3938V15.568C23.3938 20.112 26.1138 22.48 29.7938 22.48ZM56.072 29.808C60.616 29.808 64.456 28.944 66.888 27.76L64.808 21.456C62.664 22.8 59.176 23.856 55.656 23.856C53.256 23.856 51.432 23.408 51.432 22.64C51.432 22.192 51.848 21.936 52.616 21.904C53.48 22.128 54.6 22.256 55.624 22.256C61.768 22.256 65.512 18.416 65.512 13.616C65.512 11.44 64.552 9.52 62.792 8.176V7.984L65.8 5.52V4.816H55.656C49.544 4.816 45.768 8.592 45.768 13.392C45.768 16.4 47.016 18.864 49.416 20.272V20.56C46.216 20.912 44.36 22.256 44.36 24.528C44.36 27.6 48.136 29.808 56.072 29.808ZM55.656 16.304C54.248 16.304 53.192 15.216 53.192 13.872C53.192 12.496 54.216 11.472 55.624 11.472C57 11.472 58.056 12.528 58.056 13.904C58.056 15.216 57.032 16.304 55.656 16.304ZM73.7 22.48C76.228 22.48 78.404 21.392 79.364 18.768H79.62C79.524 19.952 79.332 20.88 79.012 22H88.004V4.88H79.652V13.328C79.652 14.672 78.884 15.568 77.668 15.568C76.42 15.568 75.684 14.672 75.684 13.328V4.88H67.3V15.568C67.3 20.112 70.02 22.48 73.7 22.48ZM99.0503 22.48C105.354 22.48 108.842 20.368 108.842 16.752C108.842 13.456 105.898 12.528 102.794 12.176C100.234 11.824 98.4103 11.824 98.4103 11.152C98.4103 10.576 99.5623 10.32 101.642 10.32C103.53 10.32 106.346 10.896 107.914 11.728L107.978 5.712C105.706 4.944 102.698 4.432 98.9863 4.432C92.8103 4.432 89.6743 6.64 89.6743 9.616C89.6743 13.136 92.7783 14.064 95.8503 14.384C98.3463 14.672 100.106 14.704 100.106 15.472C100.106 16.08 99.1783 16.368 96.8743 16.368C94.5383 16.368 91.9143 15.664 89.7063 14.16L89.6423 21.008C91.8503 21.744 96.4903 22.48 99.0503 22.48ZM120.606 22.48C122.782 22.48 124.99 22.192 126.974 21.584L126.91 14.704C125.982 15.088 124.958 15.376 123.678 15.376C121.63 15.376 120.35 14.736 120.35 13.072V11.28H126.686V4.88H120.35V0.4H119.518L109.726 6.672V11.28H111.998V15.216C111.998 20.208 115.998 22.48 120.606 22.48Z" fill="#5B4C37"/>
                </svg>
              </div>

              <h3>Danke für deine Anfrage!</h3>
              <p>Checke deine Emails für weitere Infos zu deinem Termin</p>
              <p> ⃰Damit wir uns nicht verfehlen, bitte denke immer daran, auch deinen Spam-Ordner zu checken.</p>

            </div>
          </div>
        </div>

        }


      </form>
  );
};

